<template>
  <div class="flex-grow">
    <div
      v-if="colorPickerVisible"
      class="floating-color-picker"
      ref="colorPicker"
      :style="{
        left: colorPickerPos.left + 'px',
        top: colorPickerPos.top + 'px',
        position: 'absolute',
        zIndex: 999
      }"
    >
      <v-card style="width: fit-content;">
        <v-color-picker
          class="ma-2"
          v-model="currentColor"
        ></v-color-picker>
        <v-card-actions class="justify-space-between">
          <v-btn
            color="primary"
            @click="resetColor()"
          ><v-icon>mdi-restart</v-icon></v-btn>
          <v-btn
            color="primary"
            @click="colorPickerVisible = false"
          >Close</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <v-row justify="center" class="mx-1" >
      <v-col class="d-flex flex-column align-stretch" :cols="12">

        <div id="osdCard" class="fullHight py-0 d-flex flex-column align-stretch" :style="isImageValid ? '' : 'display: none!important'" >
          <div
            ref="mouseWheelOverlay"
            id="instructions"
              :absolute="true"
              :value="mouseWheelOverlay"
              opacity="0.8"
              class="hidden"
            >
              <h3>Press ctrl or use two fingers to navigate on the image!</h3>
          </div>
          <v-row>
            <v-col>
              <div class="py-1 d-flex flex-column align-stretch" ref="osdDiv" :id="'openseadragonAnno' + itemId" style="height:100%;width:100%;">
                <v-row no-gutters height="6%" ref="button" class="mt-1" :attach="'#openseadragonAnno' + itemId" style='position: relative;z-index: 4;margin:auto!important'>
                  <v-bottom-sheet
                    v-model="sheet"
                    inset
                    hide-overlay
                    style="overflow-y: scroll:  !important;;"
                    :attach="'#openseadragonAnno' + itemId"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-row
                      class="mb-n1"
                      no-gutters
                      >
                        <v-col
                        v-if="$vuetify.breakpoint.smAndDown"
                        style="text-align: center;"
                        cols="12"
                        >
                          <v-btn
                          small
                          v-if="true"
                          class="text-xs-center primary"
                          :attach="'#openseadragonAnno' + itemId"
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on">
                            {{getLabelOpenAnnotations(attrs)}}
                          </v-btn>
                          <v-btn
                            small
                            dark
                            v-if="(isTouchDevice) && treeShowOption"
                            color="primary"
                            v-on:click="switchAnnoImageControl()"
                          >
                            {{actControl}}
                          </v-btn>
                        </v-col>
                        </v-row>
                    </template>
                      <v-sheet
                        :attach="'#openseadragonAnno' + itemId"
                        class="text-center"
                        height="70%"
                        style="overflow-y: visible;"
                      >
                        <div class="tree-height">
                          <div class="sheet-header">
                            <v-btn
                            class="mt-3"
                              small
                              dark
                              color="primary"
                              @click="sheet = false"
                            >
                              close
                            </v-btn>
                          </div>

                          <!-- Scrollbarer Inhalt -->
                          <div class="sheet-content">
                          <v-text-field
                            v-model="search"
                            label="Search Iconography Tree"
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle-outline" ></v-text-field>
                          <v-treeview
                            class="tree-height"
                            id="annoTree"
                            selection-type="leaf"
                            :filter="filter"
                            :search="search"
                            return-object
                            v-model="icoSelected"
                            rounded
                            selectable
                            hoverable
                            open-all
                            :items="this.icoAnnos"
                            dense
                            multiple-active
                            :active="icoActivated"
                          >
                            <template class="v-treeview-node__label" slot="label" slot-scope="{ item }">
                              <a :id="itemId + '-tree1-iconographyID-'+item.iconographyID"  @click="clickAnno(item)" @mouseover="mouseOverNode(item)"
                              @mouseleave="mouseLeaveNode(item)"><div class="v-treeview-node__label">{{ item.name }}</div></a> <a :href="getIconographyLink(item)">[go to]</a>
                            </template>
                          </v-treeview>
                          </div>
                        </div>
                  </v-sheet>
                </v-bottom-sheet>
                </v-row>
              </div>
            </v-col>
            <v-col style="max-width: 250px;" v-show="imageInfo" >
              <div :id="'openseadragonAnno-Info' + itemId"></div>
            </v-col>
          </v-row>
        <v-alert
            class="mx-1"
            :value="isDrawing"
            color="grey"
            dense
            border="top"
            icon="mdi-alert"
            transition="scale-transition"
            dismissible
            style="font-size:10px;line-height:1;"
          >
            Drawing not to scale; the proportions of the original may not be reproduced accurately.
        </v-alert>
        <v-alert
            class="mx-1"
            :value="isExpiring"
            color="yellow"
            dense
            border="top"
            icon="mdi-alert"
            transition="scale-transition"
            dismissible
            style="font-size:10px;line-height:1;"
          >
            Warning: The publication rights for this picture are to be revoked on: {{new Date(image.expiresAt).toDateString()}}
        </v-alert>
      </div>
        <v-card height="100%" class="d-flex flex-column align-stretch" :style="isImageValid ? 'display: none!important' : ''">
          <v-card-title class="justify-center pt-15 font-weight-bold text-h5" style="word-break: break-word;">
            {{getAnnoTitle(image)}}
          </v-card-title>
          <v-card-text  v-if="!isImageValid && getAccessLevel(image) === 1" class="pa-10">
            Annotations are based on an Image from:<p>
            {{image.copyright}}
            </p>
            <p>For further information, please contact <a href= "mailto:kucha@saw-leipzig.de">the project</a></p>
          </v-card-text>
          <v-card-text  v-if="!isImageValid && getAccessLevel(image) === 0" class="pa-10">
            No image available!
            <p>For further information, please contact <a href= "mailto:kucha@saw-leipzig.de">the project</a></p>
          </v-card-text>
        </v-card>

      </v-col>
      <v-col class="d-flex align-stretch"
              v-if="false"
              :order="left ? 1 : 3" :cols="getCols('AnnoTree')"  :ref="'cardAnno' + itemId" style="max-height: 80vh;">
        <v-card
          style='overflow-y: scroll;
            overflow-x: hidden;
            flex: 1 1 0;'>
          <v-row>
            <v-col cols=1>
              <v-btn icon @click="changeSize()" dense block color="black"><v-icon>{{ annoArrow ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon></v-btn>
            </v-col>
            <v-col>
              <v-text-field
                v-model="search"
                label="Search Iconography Tree"
                hide-details
                clearable
                clear-icon="mdi-close-circle-outline" >
              </v-text-field>
            </v-col>
          </v-row>
          <v-treeview
          id="annoTree2"
          class="align-stretch"
            item-disabled="locked"
            selection-type="independent"
            :filter="filter"
            :search="search"
            return-object
            v-model="icoSelected"
            rounded
            selectable
            hoverable
            open-all
            multiple-active
            :active="icoActivated"
            :items="this.icoAnnos"
            style="max-height: 100%;"
            dense>
            <template class="v-treeview-node__label" slot="label" slot-scope="{ item }">
              <div style="display: flex;">
              <div class="v-treeview-node__label" :id="'tree2-iconographyID-'+item.iconographyID"> <span @mouseover="mouseOverNode(item)" @click="clickAnno(item)"
                @mouseleave="mouseLeaveNode(item)">{{ item.name }}</span> <a style="min-width: 54px;" :href="getIconographyLink(item)">[go to]</a> </div>
              </div>
            </template>
          </v-treeview>
        </v-card>
      </v-col>
      </v-row>
    </div>
</template>
<script>
import {getOSDURL, getIconographyByAnnos, setOSDImgInfo, getIconographyByAnnosInGivenTree, isSafari, deviceType, getIco, getCaveShortLabel} from  "@/utils/helpers"
import {getIconogrpaphyByTimestamp} from '@/services/repository'
import {imageTypeDict} from '@/utils/constants.js'
import * as d3 from "d3";
import OpenSeadragon from 'openseadragon'
import { v4 as uuidv4 } from 'uuid';
import { isMobile } from "../utils/helpers.js";

const Annotorious = window.Annotorious;
const SelectorPack = window.AnnotoriousSelectorPack;


export default {
  name: 'AnnotatedImageView',
  components: {
  },
  props: {
    isImageValid:{
      type: Boolean,
      default: function () {
        return false;
      }
    },
    isVersion:{
      type: Object,
      default: function(){
        return {
          "date": "current"
        }
      }
    },
    showControls: {
      type: Boolean,
      default: true
    },
    item: {},
    image: {
      type: Object,
      default: function () {
        return {}
      }
    },
    left: {
      type: Boolean,
      default: false
    },
    isZoom: {
      type: Boolean,
      default: false
    },
    hideTree: {
      type: Boolean,
      default: false
    },
    treeShowOption: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    presentationMode: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    icoActivated: {
      type: Array,
      default: function () {
        return []
      }
    },
    relativeHeight: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    highlightedAnnotations: {
      type: Array,
      default: function () {
        return []
      }
    },
    relatedAnnotations: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  emits: ['icoSelectedChanged', 'hoveredItemChanged', 'selectedAnnosChanged', 'setHighlightedIcos'],
  data () {

    return {
      selectedAnnos:[],
      hoveredItem: null,
      imageInfo: false,
      isDrawing: false,
      isExpiring: false,
      dontShowTree: true,
      showTag:false,
      viewerAnnos: null,
      w3cAnnos: [],
      annotoriousplugin: {},
      icoAnnos: [],
      actControl:"Explore",
      isFullScreen: false,
      icoSelected: [],
      search: null,
      annoArrow: false,
      annoImg: null,
      colsAnnoImg:8,
      colsAnnoTree:4,
      hoveredAnno:{},
      sheet:false,
      uniqueID: uuidv4(),
      mouseWheelOverlay: false,
      isMounted: false,
      clientX: 0,
      clientY: 0,
      colorPickerVisible: false,
      colorSelectingAnno: null,
      colorPickerPos: {
        left: 0,
        top: 0
      },
      currentColor: {r: 0, g: 128, b: 0, a: 0.25 },
      annoColor: {},
      touchStart: 0,
      TAP_THRESHOLD: 10,

    }
  },
  computed: {
    isMobile(){
      return isMobile()
    },
    deviceType(){
      this.$log.debug("deviceType", deviceType())
      return deviceType()
    },
    user () {
      return this.$store.state.user
    },
    isTouchDevice() {
      return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
    },

    setHeight(){
      if (this.relativeHeight){
        return this.$vuetify.breakpoint.smAndDown ? 'height:100%;display: flex;' : 'flex:1;display: flex;'
      } else {
        return this.$vuetify.breakpoint.smAndDown ? 'height:100%;display: flex;' : 'flex:1;display: flex;'
      }
    },
    yTag(){
      if (this.dontShowTree){
        if (this.$refs['osdDiv']){
          return this.$refs['osdDiv'].getBoundingClientRect().y
        }
      } else {
        if (this.$refs['cardAnno' + this.itemId]){
          return this.$refs['cardAnno' + this.itemId].getBoundingClientRect().y - 10
        }
      }
      return 0
    },
    xTag(){
      this.$log.debug("xTag", this.dontShowTree)
      if (this.dontShowTree){
        if (this.$refs['osdDiv']){
          this.$log.debug("xTag osdDiv", this.$refs['osdDiv'].getBoundingClientRect().x)
          return this.$refs['osdDiv'].getBoundingClientRect().x
        }
      } else {
        if (this.$refs['cardAnno' + this.itemId]){
          this.$log.debug("xTag cardAnno", this.$refs['cardAnno' + this.itemId].getBoundingClientRect().x)
          return this.$refs['cardAnno' + this.itemId].getBoundingClientRect().x
        }
      }
      this.$log.debug("xTag 0", this.$refs['osdDiv'].getBoundingClientRect(), this.$refs['cardAnno' + this.itemId].getBoundingClientRect().x)
      return 0
    },
    itemId(){
      return this.uniqueID
    },
    filter () {
      return  (item, search, textKey) => {
        if (item.search) {
          // .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          return (item["search"].toLowerCase().normalize("NFD").indexOf(search) > -1 || item["name"].toLowerCase().normalize("NFD").indexOf(search) > -1)
        } else {
          return (item["name"].toLowerCase().normalize("NFD").indexOf(search) > -1)
        }
      }
    },
  },
  methods: {
    resetColor() {
      this.currentColor = {r: 0, g: 128, b: 0, a: 0.25 };
      this.annoColor[this.colorSelectingAnno.id] = null
      this.colorPickerVisible = false
    },
    applyColor() {
      const anno = this.currentAnnotation;

      let body = anno.bodies?.find(b => b.purpose === "highlighting");

      if (!body) {
        body = {
          type: "TextualBody",
          purpose: "highlighting",
          value: this.currentColor
        };
        anno.bodies = [...(anno.bodies || []), body];
      } else {
        body.value = this.currentColor;
      }

      this.annotoriousplugin.updateAnnotation(anno);
    },

    findElementinTree(element, tree){
      if (element.iconographyID === tree.iconographyID){
        return tree
      } else {
        for (let child of tree.children){
          let res = this.findElementinTree(element, child)
          if (res !== null){
            return res
          }
        }
        return null
      }
    },
    getIconographyLink(item){
      return window.location.origin  + "/iconography/" + item.id
    },
    clickAnno(item){
      let found = false
      let filteredAnnos = []
      for (let anno of this.icoSelected){
        if (anno.id === item.id){
          found = true
        } else {
          filteredAnnos.push(anno)
        }
      }
      if (found) {
        this.icoSelected = filteredAnnos
      } else {
        this.icoSelected.push(item)
      }
    },
    getLabelOpenAnnotations(attrs){
      if (attrs["aria-expanded"] !== "true"){
        return "Open Annotations"
      } else {
        return "Close Annotations"
      }
    },
    handleClick(event){
      this.$log.debug("click!", event);
      if (event.pointerType === "touch"){
        this.$log.debug("is touch");
      }
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(
        function() {
          /* clipboard successfully set */
        },
        function() {
          /* clipboard write failed */
        }
      )
    },
    setSelectedAnno(annotations){
      this.$log.debug("setSelectedAnno in AnnotatedImageView", annotations.map(x => this.w3cAnnos.find(y => y.id === x)))
      this.selectedAnnos = annotations.map(x => this.w3cAnnos.find(y => y.id === x))
    },
    doSelectOrCopy(annotation, evt){
      const findIndex = this.selectedAnnos.findIndex(x => x.id === annotation.id)
      if (findIndex > -1){
        this.selectedAnnos.splice(findIndex, 1)
        this.annoColor[annotation.id] = null

      } else {
        this.colorSelectingAnno = annotation
        this.$log.debug("color picker", annotation, evt)
        const rect = evt.getBoundingClientRect();
        const viewerRect = this.viewerAnnos.container.getBoundingClientRect();

        const pickerWidth  = this.$refs.colorPicker?.offsetWidth  || 300;
        const pickerHeight = this.$refs.colorPicker?.offsetHeight || 250;
        if (this.annoColor[annotation.annotoriousID]){
          this.currentColor = {r: this.annoColor[annotation.annotoriousID].r, g: this.annoColor[annotation.annotoriousID].g, b: this.annoColor[annotation.annotoriousID].b, a: this.annoColor[annotation.annotoriousID].a}
        } else {
          this.currentColor = {r: 0, g: 128, b: 0, a: 0.25 }
        }
        let left = rect.x + rect.width;
        let top  = rect.y;

        if (left + pickerWidth > viewerRect.right) {
          left = rect.x - pickerWidth;
        }

        if (top + pickerHeight > window.innerHeight) {
          top = window.innerHeight - pickerHeight - 10;
        }

        this.colorPickerPos = { left, top };

        this.colorPickerVisible = true
        this.selectedAnnos.push(annotation)
      }
      this.$emit('selectedAnnosChanged', this.selectedAnnos)
      this.updateSelectedAnnos
    },
    getCols(col){
      if (this.$vuetify.breakpoint.mdAndDown){
        return "12"
      } else if (this.dontShowTree) {
        return "12"
      } else {
        if (col === "AnnoImg"){
          return this.colsAnnoImg
        } else {
          return this.colsAnnoTree
        }
      }
    },

    getAccessLevel(item){
      if (item){
        if (item.accessLevel){
          if (item.accessLevel === 2){
            if (item.isExpiring){
              if (item.expiresAt <= Date.now()){
                return 1
              } else {
                return item.accessLevel
              }
            } else {
              return item.accessLevel
            }
          }
          return item.accessLevel
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    getAnnoTitle(item){
      return this.getAccessLevel(item) === 1 ?  "Access to the picture is restricted due to copyright reasons." : "Picture is not available."
    },
    mouseLeaveAnnotation(annotation, evt){
      if (!this.isTouchDevice || (this.isTouchDevice && this.actControl === "Navigate")){
        this.$log.debug("mouseLeaveAnnotation", annotation, this.highlightedAnnotations)
        if (!this.highlightedAnnotations.includes(annotation.id)) {
          this.icoActivated
        }
        this.showTag = false
        this.hoveredAnno = null
        this.updateSelectedAnnos()
        this.$emit('annoHoverOut', annotation)
      }
    },
    deselectAnnotation(annotation){
      if (this.hoveredAnno === annotation){
        this.hoveredAnno = null
        this.showTag = false
      } else {
        setTimeout(this.deselectAnnotation, 5000, annotation)
      }
    },
    mouseEnterAnnotation(annotation, evt){
      if (!annotation.id) return
      this.$log.debug("mouseEnterAnnotation", annotation)
      annotation.motivation = "highlight"
      this.annotoriousplugin.format(annotation)
      this.hoveredAnno = annotation
      this.showTag = true
      setTimeout(this.deselectAnnotation, 5000, annotation)

      this.$emit('annoHover', annotation)
    },
    changeSize(){
      if (this.annoArrow){
        this.colsAnnoImg = 8
        this.colsAnnoTree = 4
        this.annoArrow = false
      } else {
        this.colsAnnoImg = 6
        this.colsAnnoTree = 6
        this.annoArrow = true
      }
    },
    switchimageControl(){
      if (this.actControl !== "Navigate"){
        this.actControl = "Navigate"
        this.viewerAnnos.setControlsEnabled(true)
        this.viewerAnnos.setMouseNavEnabled(true)
      } else {
        this.actControl = "Explore"
        this.viewerAnnos.setControlsEnabled(false)
        this.viewerAnnos.setMouseNavEnabled(false)
      }
    },
    mouseOverNode(item){
      if (!item.locked){
        var foundAnnos = this.getAnnoByIcoID(item)
        this.$log.debug("mouse over!", foundAnnos)
        this.hoveredItem = foundAnnos
        for (var anno of foundAnnos){
          var dummy = this.annotoriousplugin.getAnnotations().find(element => element.id === anno.annotoriousID)
          if (dummy){
            if (!Array.isArray(dummy)){
              dummy.motivation = "highlight"
              this.annotoriousplugin.format(dummy)
            } else {
              for (var w3c of dummy){
                w3c.motivation = "highlight"
                this.annotoriousplugin.format(w3c)
              }
            }
          }
        }
        this.viewerAnnos.forceRedraw()
      }
    },
    async getIiifInfo(filename) {
      const infoUrl = `${process.env.VUE_APP_IIIFAPI}/iiif/2/kucha%2Fimages%2F${filename}/info.json`;
      const res = await fetch(infoUrl);
      return await res.json();
    },
async downloadImg() {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const info = await this.getIiifInfo(this.image.filename);

      const imgWidth = info.width;
      const imgHeight = info.height;

      canvas.width = imgWidth;
      canvas.height = imgHeight;

      const viewerImage = this.viewerAnnos.world.getItemAt(0);
      const viewportSize = viewerImage.getContentSize();

      const scaleX = imgWidth / viewportSize.x;
      const scaleY = imgHeight / viewportSize.y;

      // Basis-URL aus info.json holen (IIIF v2 nutzt '@id', v3 nutzt 'id')
      const baseUrl = info['@id'] || info.id;
      const imgUrl = `${baseUrl}/full/max/0/default.jpg`;

      // Bild über full/max laden
      const img = new Image();
      img.crossOrigin = "Anonymous"; // Wichtig für canvas.toDataURL (verhindert CORS-Fehler)

      await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
        img.src = imgUrl;
      });

      // Das komplette Bild auf einmal auf den Canvas zeichnen
      ctx.drawImage(img, 0, 0, imgWidth, imgHeight);

      // Annotationen zeichnen
      this.drawAnnotations(ctx, scaleX, scaleY);

      // --- DOWNLOAD ---
      const link = document.createElement('a');
      link.download = `KMIS_${imageTypeDict[this.image.imageTypeID]}_${this.image.imageAuthor.name.replace(" ", "_")}_${this.getItemName(this.item)}_Image-ID_${this.image.imageID}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    },
    async drawIiifTile(ctx, x, y, w, h) {
      return new Promise((resolve, reject) => {
        const tileUrl =
          `${process.env.VUE_APP_IIIFAPI}/iiif/2/kucha%2Fimages%2F${this.image.filename}` +
          `/${x},${y},${w},${h}/${w},${h}/0/default.jpg`;

        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = tileUrl;

        img.onload = () => {
          ctx.drawImage(img, x, y, w, h);
          resolve();
        };

        img.onerror = reject;
      });
    },
    drawAnnotations(ctx, scaleX, scaleY) {
      const annos = this.annotoriousplugin.getAnnotations();

      annos.forEach(a => {
        if (
          (a.motivation === "highlight" &&
          this.selectedAnnos.some(x => x.id === a.id)) ||
          this.icoSelected.some(x =>
            x.w3cAnno.some(y => y.id === a.id)
          )
        ) {
          const selector = a?.target?.selector?.value;
          if (!selector) return;

          const match = selector.match(/d="([^"]+)"/);
          if (!match) return;

          const scaledPath = this.scaleSvgPath(match[1], scaleX, scaleY);
          const path = new Path2D(scaledPath);
          if (this.annoColor[a.id]){
            ctx.fillStyle = this.annoColor[a.id].motivation;
          } else {
            ctx.fillStyle = "rgba(0, 128, 0, 0.3)";
          }
          ctx.fill(path);
        }
      });
    },


    scaleSvgPath(d, scaleX, scaleY) {
      return d.replace(/([-+]?\d*\.?\d+(?:e[-+]?\d+)?)/gi, (num, index) => {
        // abwechselnd X / Y Werte skalieren
        return index % 2 === 0 ? num * scaleX : num * scaleY;
      });
    },
    mouseLeaveNode(item){
      this.hoveredItem = []
      this.updateSelectedAnnos()
    },
    setAnnotationsForImage(){
      let annotations = []
      if (this.getAccessLevel(this.image) > 1){
        for (let anno of this.w3cAnnos){
          if (anno) {
            if (this.image.filename === anno.target.source){
              annotations.push(anno)
            }
          }
        }
      }
      this.annotoriousplugin.setAnnotations(annotations)
    },
    updateSelectedAnnos(){
      this.$log.debug("updateSelectedAnnos", this.highlightedAnnotations, this.annotoriousplugin.getAnnotations().length)
      if (this.getAccessLevel(this.image) > 1){
        let annotations = this.annotoriousplugin.getAnnotations()
        for (let anno of annotations){
          anno.motivation = "hide"
          for (var body of anno.body){
            for (var icoAnno of this.icoSelected) {
              if (body.id === icoAnno.iconographyID && anno.motivation === "hide"){

                anno.motivation = "highlight"
              }
            }
          }
          if (this.hoveredAnno !== null && this.getAccessLevel(this.image) === 2){
            if (anno.id === this.hoveredAnno.id){
              anno.motivation = "highlight"
            }
          }
          if (this.selectedAnnos && this.getAccessLevel(this.image) === 2){
            if (this.selectedAnnos.find(element => element.id === anno.id)){
              anno.motivation = "highlight"
            }
          }
          if (this.highlightedAnnotations && this.getAccessLevel(this.image) === 2){
            for (const annotoriousID of this.highlightedAnnotations){
              if (anno.id === annotoriousID){
                anno.motivation = "highlight"
                break;
              }
            }
          }
          this.annotoriousplugin.format(anno)
        }
      }
    },
    hoveredTags(hoveredAnno){
      // this.$log.debug("hoveredTags", hoveredAnno);
      let tags = ""
      if (hoveredAnno){
        if (hoveredAnno.body){
          for (let tag of hoveredAnno.body){
            if (tags === ""){
              tags = tag.value
            } else {
              tags += "/" + tag.value
            }
          }
        }
      }
      return tags
    },
    getThumbnail(image){
      return process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fimages%2F" + image.filename + "/full/!80,80/0/default.jpg"
    },
    setOSDImgOverlayAnno(){
      this.imageInfo = !this.imageInfo
    },
    initOSDanno(){
      this.$log.debug("initOSDanno", this.user);
      let tilesAnnos = []
      tilesAnnos = getOSDURL(this.image)
      let options = {
        id: 'openseadragonAnno' + this.itemId,
        prefixUrl: '/static/',
        tileSources: tilesAnnos,
        preserveViewport: true,
        showRotationControl: true,
        showFlipControl: true,
        maxZoomLevel: 100,
        visibilityRatio: 1.0,
        defaultZoomLevel: 0,
        minZoomLevel: 0.001,
        ...(this.user.sessionID && this.user.sessionID !== "" && {
            ajaxWithCredentials: true,
            loadTilesWithAjax: true,
            tileRequestHeaders: { "Authorization": `Bearer ${this.user.sessionID}` },
            ajaxHeaders: { "Authorization": `Bearer ${this.user.sessionID}` }
          })
      }
      if (!this.showControls){
        options['showNavigationControl'] = false
      }
      this.viewerAnnos = OpenSeadragon(options)
      this.$log.debug("viewerAnnos", this.viewerAnnos);
      this.viewerAnnos.setControlsEnabled(true)
      if (this.getAccessLevel(this.image) === 2) {
        // this.$refs['osdDiv'].onwheel = this.handleScroll;
        // this.$refs['osdDiv'].touchmove = this.handleTouch;
      }
      const canvases = document.getElementsByClassName('openseadragon-canvas')
      for (const canvas of canvases)  {

        canvas.style.touchAction = 'pan-y'
      //   this.$log.debug("canvas.style", canvas.style);
      //   this.viewerAnnos.addViewerInputHook({ hooks: [
      //     {tracker: 'viewer',
      //       handler: 'scrollHandler',
      //       hookHandler: function (event) {
      //       }},
      //   ]});

      //   // Handle drag scroll.
      //   // Only works if touch-action: pan-y else scroll event doesn't propigate to documen
      //   this.viewerAnnos.addViewerInputHook({ hooks: [
      //     {tracker: 'viewer',
      //       handler: 'dragHandler',
      //       hookHandler: function (event) {
      //       }},
      //   ]});

      //   // Finally, remove the instructions on any pinch event.
      //   // This covers both mouse and touch devices
      //   this.viewerAnnos.addViewerInputHook({ hooks: [
      //     {tracker: 'viewer',
      //       handler: 'pinchHandler',
      //       hookHandler: function (event) {
      //       }},
      //   ]});
      }
      // Handle desktop scroll

      if (this.showControls){
        if (this.image.cc){
          let infoButtonAnno = new OpenSeadragon.Button({
            tooltip: 'Download image with selected annotations',
            srcRest: '/kis/scripts/imageviewer/images/download_rest.png',
            srcGroup: '/kis/scripts/imageviewer/images/download_grouphover.png',
            srcHover: '/kis/scripts/imageviewer/images/download_hover.png',
            srcDown: '/kis/scripts/imageviewer/images/download_pressed.png',
            onClick: this.downloadImg
          })
          this.viewerAnnos.addControl(infoButtonAnno.element, { anchor: OpenSeadragon.ControlAnchor.TOP_LEFT });
        }
        this.viewerAnnos.addHandler('canvas-click', this.handleViewerClick);
      }
      var MyHighlightFormatter = function(annotation) {
        if (annotation.motivation === "highlight"){
          if (_self.annoColor && _self.annoColor[annotation.id]){
            _self.$log.debug("MyHighlightFormatter", annotation, _self.annoColor)
            const style = `stroke-width:0px!important;  fill: ${_self.annoColor[annotation.id].motivation};vector-effect: none;`
            return {

              'style': style
            }
          } else {
            return {
              'style': 'stroke-width:0px;stroke: gold;  fill: rgba(0, 128, 0,0.25);vector-effect: none;'
            }
          }
        } else {
          return {
            'style': 'stroke-width:0px!important;  fill: rgba(0, 128, 0,0);vector-effect: none;'
          }
        }
      }
      // var MyHighlightFormatter = function(annotation) {
      //   if (annotation.motivation === "highlight"){
      //     return "highlight"
      //   } else {
      //     return "hide"
      //   }
      // }
      var config = {};
      config["readOnly"] = true;
      config["widgets"] = ['COMMENT', { widget: 'TAG', vocabulary: [], showDelete: false }]
      config["image"] = this.viewerAnnos;
      config["formatters"] = [MyHighlightFormatter];
      this.$log.debug("Annotorious", config, window);
      this.annotoriousplugin = window.OpenSeadragon.Annotorious(this.viewerAnnos, config)
      Annotorious.SelectorPack(this.annotoriousplugin);
      this.viewerAnnos.setControlsEnabled(true);
      this.viewerAnnos.setMouseNavEnabled(true);
      var _self = this;
      this.annotoriousplugin.disableEditor = true
      this.annotoriousplugin.on('mouseEnterAnnotation', function(annotation, event) {
        _self.$nextTick(() => {
          _self.mouseEnterAnnotation(annotation, event)
        })
      });

      this.annotoriousplugin.on('mouseLeaveAnnotation', function(annotation, evt) {
        _self.mouseLeaveAnnotation(annotation, evt)
      });

      this.annotoriousplugin.on('cancelSelected', function(annotation, evt) {
        // this.$log.debug("deselection", evt);
      });
      this.annotoriousplugin.on('clickAnnotation', function(annotation, evt) {
        if (!_self.isTouchDevice || (_self.isTouchDevice && _self.actControl === "Navigate")){
          _self.$log.debug("is navigate!");
          if (annotation.id !== _self.hoveredAnno.id){
            _self.mouseEnterAnnotation(annotation, evt)
          } else {
            if (!_self.mouseWheelOverlay){
              _self.$log.debug("selectOrCopy", annotation);
              _self.doSelectOrCopy(annotation, evt)
            }
          }
        }
        setTimeout(function(){ _self.annotoriousplugin.selectAnnotation();}, 1000);
      });

      this.viewerAnnos.addHandler("open", function (data) {
        if (_self.$refs.osdDiv !== undefined){
          if (_self.$refs.osdDiv.clientHeight > 0){
            // this.$log.debug("osdDiv", _self.$refs.osdDiv);
            _self.goHome(true)
          }
        }
      });
      this.viewerAnnos.addHandler("tile-loaded", function (data) {
        // _self.viewerAnnos.viewport.goHome(true)
      });
      const annotationLayers = document.getElementsByClassName('a9s-annotationlayer')
      for (const canvas of annotationLayers){
        canvas.style.touchAction = 'pan-y'
      }
      document.getElementById('openseadragonAnno' + this.itemId).addEventListener('fullscreenchange', (event) => {
        if (document.fullscreenElement) {
          _self.isFullScreen = true
        } else {
          _self.isFullScreen = false
          _self.sheet = false
        }
      });
      this.viewerAnnos.addHandler("pre-full-page", function (data) {
        if (!isSafari){
          data.preventDefaultAction = true;
          if (data.eventSource.element.requestFullscreen) {
            data.eventSource.element.requestFullscreen();
          } else if (data.eventSource.element.mozRequestFullScreen) {
            data.eventSource.element.mozRequestFullScreen();
          } else if (_self.viewerAnnos.drawer.canvas.webkitRequestFullscreen) {
            // data.eventSource.element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            _self.viewerAnnos.drawer.canvas.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          } else if (data.eventSource.element.msRequestFullscreen) {
            data.eventSource.element.msRequestFullscreen();
          } else if (_self.viewerAnnos.drawer.canvas.webkitEnterFullScreen) {
            // data.eventSource.element.webkitEnterFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            _self.viewerAnnos.drawer.canvas.webkitEnterFullScreen(Element.ALLOW_KEYBOARD_INPUT);
          } else {
            _self.viewerAnnos.drawer.canvas.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          }
        } else {
          console.log("safari browser!");

        }
      });
    },
    getItemID(){
      if (this.item.ornamentID){
        return "ornament_" + this.item.ornamentID
      }
      if (this.item.depictionID){
        return "depiction" + this.item.depictionID
      }
      if (this.item.iconographyID){
        return "iconography" + this.item.iconographyID
      }
    },
    disableTree() {
      for (let rootItem of this.icoAnnos){
        rootItem.locked = true
      }
    },
    enableTree() {
      for (let rootItem of this.icoAnnos){
        rootItem.locked = false
      }
    },
    getAnnoByIcoID(item){
      var annosFound = [];
      for ( var anno of this.relatedAnnotations){
        for ( var ie of anno.tags){
          if (ie.iconographyID === item.iconographyID){
            annosFound.push(anno)
          }
        }
      }
      if (item.children){
        if (item.children.length > 0){
          for (var child of item.children){
            var result = []
            result = this.getAnnoByIcoID(child)
            if (result.length > 0){
              annosFound = annosFound.concat(result)
            }
          }
        }
      }
      return annosFound
    },
    hideAnnotation(w3cAnnoID){
      var annoToHide = this.annotoriousplugin.getAnnotationById(w3cAnnoID)
      if (annoToHide) {
        annoToHide['motivation'] = "hide"
        this.annotoriousplugin.format(annoToHide)
      }
    },
    addAnnotation(w3cAnno){
      var annoToHighlight = this.annotoriousplugin.getAnnotationById(w3cAnno)
      if (annoToHighlight) {
        annoToHighlight["motivation"] = "highlight"
        this.annotoriousplugin.format(annoToHighlight)
      }
    },
    setOSDannos(image){
      this.enableTree();
      this.image = image
      if (this.image.imageTypeID === 5){
        if (this.showControls){
          this.isDrawing = true
        } else {
          this.isDrawing = false
        }
      } else {
        this.isDrawing = false
      }
      if (this.image.isExpiring && this.image.expiresAt > Date.now()){
        this.isExpiring = true
      } else {
        this.isExpiring = false
      }
      this.viewerAnnos.open(getOSDURL(image))
      this.viewerAnnos.viewport.goHome(true)
      this.setAnnotationsForImage()
      this.updateSelectedAnnos()
    },
    getIco(element, id){
      getIco(element, id)
    },
    putW3cInAnnos(anno){
      for (let rootItem of this.icoAnnos){
        this.findInTree(rootItem, anno)
      }
    },
    resize(){
      const _self = this
      if (this.viewerAnnos){
        // this.viewerAnnos.resize();
        setTimeout(function(){
          _self.viewerAnnos.viewport.goHome(true)
        }, 100);
      }
    },
    seticoSelected(icoSelected){
      this.$log.debug("seticoSelected in AnnotatedImageView", icoSelected)
      this.icoSelected = [...icoSelected]
    },
    findInTree(element, w3cAnno){
      for (let body  of w3cAnno.body){
        if (body.id === element.iconographyID){
          element.w3cAnno.push(w3cAnno)
        }
      }
      for (let child of element.children){
        this.findInTree(child, w3cAnno)
      }
    },
    formatName(str, limit) {
      if (str.length <= limit) return str.replace(/\s+/g, "_");

          let cut = str.substring(0, limit);
          let lastSpace = cut.lastIndexOf(" ");

          // Am letzten Leerzeichen abschneiden, um halbe Wörter zu vermeiden
          if (lastSpace > 0) {
            cut = cut.substring(0, lastSpace);
          }

          return (cut + "_etc").replace(/\s+/g, "_");
    },
    getItemName(item){
      if (item.iconographyID){
        return ("KMT-ID_" + item.ornamentID + "_" + this.formatName(item.name, 10))
      }

      if (item.depictionID){
        if (item.shortName && item.shortName.length > 0){
          return ("PR-ID_" + item.depictionID   + "_" + this.formatName(item.shortName) + "_" + getCaveShortLabel(item.cave))
        } else {
          return ("PR-ID_" + item.depictionID)
        }
      }
    },
    initNewAnnotatedImage(doW3c){
      this.$log.debug("initNewAnnotatedImage in AnnotatedImageView", doW3c)
      if (document.getElementById('openseadragonAnno' + this.itemId)){
        if (doW3c){
          var allAnnotationEntries = []
          this.w3cAnnos = []
          var geoGenerator = d3.geoPath()
          for (var ae of this.relatedAnnotations) {
            for (var ico of ae.tags) {
              if (!allAnnotationEntries.includes(ico)) {
                allAnnotationEntries.push(ico.iconographyID);
              }
            }
            // It happened, that sometimes, w3c Annotations were not properly converted. In this cases, just the string representation of the w3c-object was stored. To allow to present the annotation anyway, the system tests here for the String-representation to prevent errors. Do: check, if '[object Object]' is still produced or if this is has just been a left over.
            if (ae.w3c && ae.w3c !==  "[object Object]"){
              if (typeof ae.w3c === 'string' || ae.w3c instanceof String) {
                this.w3cAnnos.push(JSON.parse(ae.w3c))
              } else {
                this.w3cAnnos.push(ae.w3c)
              }
            } else {
              var bodies = []
              for (var ie of ae.tags) {
                if (!allAnnotationEntries.includes(ie)) {
                  var body = {};
                  body["type"] = "TextualBody";
                  if (ie.name){
                    body["value"] = ie.name;
                  } else {
                    body["value"] = ie.text;
                  }
                  body["id"] = ie.iconographyID;
                  body["image"] = ae.image;
                  bodies.push(body);
                }
              }
              var anno = {};
              anno["@context"] = "http://www.w3.org/ns/anno.jsonld";
              anno["id"] = ae.annotoriousID;
              anno["type"] = "Annotation";
              anno["motivation"] = "highlight"
              anno["body"] = bodies;
              var target = {};
              var selector = {};
              selector["type"] = "SvgSelector";
              selector["conformsTo"] = "http://www.w3.org/TR/media-frags/";
              var root
              if (ae.polygon){
                root = JSON.parse(ae.polygon);
              } else {
                root = JSON.parse(ae.geoJson);
              }
              selector["value"] = "<svg><path d=\"" + geoGenerator(root) + "\"></path></svg>";
              target["selector"] = selector;
              target["id"] = ae.image
              anno["target"] = target;
              this.w3cAnnos.push(anno);

            }
          }
          const _self = this
          if (this.isVersion){
            if (this.isVersion.date.toString().includes('current')){
              this.icoAnnos = getIconographyByAnnos(allAnnotationEntries)
            } else {
              getIconogrpaphyByTimestamp(this.isVersion._source.timestamp)
                .then( res => {
                  _self.icoAnnos = getIconographyByAnnosInGivenTree(allAnnotationEntries, res.data.hits.hits[0]._source.content.iconographyTree)
                }).catch(function (error) {
                  _self.$log.debug(error)
                  return null
                })
              this.icoAnnos = getIconographyByAnnos(allAnnotationEntries)

            }
          } else {
            this.icoAnnos = getIconographyByAnnos(allAnnotationEntries)
          }
          for (let w3cAnno of this.w3cAnnos){
            this.putW3cInAnnos(w3cAnno)
          }

        }
        OpenSeadragon.setString('Tooltips.SelectionT@focus="$event.target.select()"oggle', 'Selection Demo');
        OpenSeadragon.setString('Tooltips.SelectionConfirm', 'Ok');
        OpenSeadragon.setString('Tooltips.HorizontalGuide', 'Add Horizontal Guide');
        OpenSeadragon.setString('Tooltips.VerticalGuide', 'Add Vertical Guide');
        OpenSeadragon.setString('Tooltips.ImageTools', 'Image tools');
        OpenSeadragon.setString('Tool.brightness', 'Brightness');
        OpenSeadragon.setString('Tool.contrast', 'Contrast');
        OpenSeadragon.setString('Tool.thresholding', 'Thresholding');
        OpenSeadragon.setString('Tool.invert', 'Invert');
        OpenSeadragon.setString('Tool.gamma', 'Gamma');
        OpenSeadragon.setString('Tool.greyscale', 'Greyscale');
        OpenSeadragon.setString('Tool.reset', 'Reset');
        OpenSeadragon.setString('Tool.rotate', 'Rotate');
        OpenSeadragon.setString('Tool.close', 'Close');
        if (this.viewerAnnos === null){
          this.initOSDanno()
        }
        //this.icoSelected = []
        if (Object.keys(this.annotoriousplugin).length > 0){
          let shownAnnos = []
          for (let anno of this.w3cAnnos){
            if (this.image.filename === anno.target.source){
              anno.motivation = this.highlightedAnnotations.includes(anno.id) ? "highlight" : "hide"
              const preselectedIcosIDsString = Array.isArray(this.$route.query.iconography) ? this.$route.query.iconography : [this.$route.query.iconography]
              const preselectedIcosIDs = preselectedIcosIDsString.map(icoID => parseInt(icoID, 10))
              for (const body of anno.body){
                this.$log.debug("body", body.id, preselectedIcosIDs);
                if (preselectedIcosIDs.includes(body.id)){
                  anno.motivation = "highlight"
                  break
                }
              }
              shownAnnos.push(anno)
            }
          }
          this.$log.debug("shownAnnos", shownAnnos);
          const blob = new Blob([JSON.stringify(shownAnnos)], { type: 'application/json' })
          const url = URL.createObjectURL(blob)

          this.annotoriousplugin.loadAnnotations(url).then(() => {
            this.updateSelectedAnnos();
          });
        }
      }

    },
    handleViewerClick() {
      if (this.colorPickerVisible) {
        this.colorPickerVisible = false;
      }
    },
    handleClickOutside(event) {
      if (!this.colorPickerVisible) return;

      const picker = this.$refs.colorPicker;
      if (!picker) return;

      if (!picker.contains(event.target)) {
        this.colorPickerVisible = false;
      }
    },
    hideTag(){
      this.showTag = false
    },
    goHome(direct){
      this.$log.debug("start goHome", direct);
      const _self = this
      if (direct){
        this.$log.debug("direct goHome");
        setTimeout(function(){ _self.viewerAnnos.viewport.goHome() }, 50);
      }
      if (this.isZoom){
        let annos = []
        for (const anno of _self.annotoriousplugin.getAnnotations()){
          if (this.image.filename === anno.target.source) {
            annos.push(anno)
          }
        }
        if (annos.length > 0){
          setTimeout(function(){ _self.annotoriousplugin.fitBounds(annos, false)}, 50);
        } else {
          setTimeout(function(){ _self.viewerAnnos.viewport.goHome() }, 50);
        }
      }
    },
    selectChildren(parent){
      for (let child of parent.children){
        this.selectChildren(child)
        this.icoSelected.push(child)
      }
    },
    deselectChildren(parent){
      for (let child of parent.children){
        this.deselectChildren(child)
        const index = this.icoSelected.indexOf(child);
        if (index > -1) {
          this.icoSelected.splice(index, 1);
        }
      }
    }
  },
  watch: {
    'currentColor': function(newVal, oldVal) {
      this.$log.debug("currentColor changed", newVal, this.colorSelectingAnno);
      const motivation = `rgba(${newVal.r},${newVal.g},${newVal.b},${newVal.a})`
      this.annoColor[this.colorSelectingAnno.id] = {r:newVal.r, g:newVal.g, b:newVal.b, a:newVal.a, motivation: motivation} //motivation
      this.viewerAnnos.forceRedraw()
      this.annotoriousplugin.format(this.colorSelectingAnno)

    },
    'highlightedAnnotations': function(newVal, oldVal) {
        this.updateSelectedAnnos()
    },
    'hoveredItem': function(newVal, oldVal) {
      this.$log.debug("hoveredItem changed:", newVal);
      this.$emit('hoveredItemChanged', newVal)
    },
    'isImageValid': function(newVal, oldVal) {
      this.$log.debug("isImageValid changed:", newVal);
    },
    'image': function(newVal, oldVal) {
      if (Object.keys(newVal).length > 0){
        this.setOSDannos(newVal)
      }
    },
    'imageInfo': function(newVal, oldVal) {
      if (newVal){
        var imgInfoNode = document.getElementById('openseadragonAnno-Info' + this.itemId)
        while (imgInfoNode.firstChild) {
          imgInfoNode.removeChild(imgInfoNode.lastChild);
        }
        imgInfoNode.appendChild(setOSDImgInfo(this.image))
      }
    },
    'icoSelected': function(newVal, oldVal) {
      this.$log.debug("icoSelected changed:", newVal);
      this.$emit('icoSelectedChanged', newVal)
      let newlySelected = newVal
        .filter(x => !oldVal.includes(x))
      for (let nselected of newlySelected){
        this.selectChildren(nselected)
      }
      let newlyDeselected = oldVal
        .filter(x => !newVal.includes(x))
      for (let ndeselected of newlyDeselected){
        this.deselectChildren(ndeselected)
      }
      if (this.isMounted){
        this.updateSelectedAnnos()
      }
    },
    'anno': function (newVal, oldVal) {
      if (this.isMounted){
        const _self = this
        setTimeout(function(){ _self.viewerAnnos.viewport.goHome() }, 50);
        this.updateSelectedAnnos()
        this.goHome()
      }
    },
    'highlightedAnnotations':function (newVal, oldVal) {
      const annos = newVal.map(x => this.w3cAnnos.find(y => y.id === x))
      let icos = []
      for (let annotation of annos){
        for (let anno of annotation.body){
          if (Array.isArray(this.icoAnnos)){
            for (let ico of this.icoAnnos){
              let res = getIco(ico, anno.id)
              if (res !== null){
                icos.push(res)
                // this.$log.debug("adding annos:", res);
                break
              }
            }
          } else {
            let res = getIco(this.icoAnnos, anno.id)
            if (res !== null){
              icos.push(res)
            }
          }
        }
      }
      this.$emit('setHighlightedIcos', icos)
      this.$log.debug("highlightedAnnotations changed:", icos )
    },
    'relatedAnnotations':function (newVal, oldVal) {
      if (this.isMounted){
        if (Object.keys(this.annotoriousplugin).length > 0){
          this.annotoriousplugin.clearAnnotations();
        }
        this.initNewAnnotatedImage(true)
        this.updateSelectedAnnos()
      }
    },
    'hideTree':function (newVal, oldVal) {
      if (newVal){
        this.dontShowTree = true
      } else {
        this.dontShowTree = false
      }
    },
    'item': function (newVal, oldVal) {
    },
    'dontShowTree': function(newVal, oldVal) {
      if (this.isMounted){
        if (Object.keys(this.annotoriousplugin).length > 0){
          let _self = this
          setTimeout(function(){ _self.viewerAnnos.viewport.goHome() }, 50);
        }
      }
    },
  },
  created () {
    window.addEventListener("resize", this.resize);
  },
  beforeDestroyed () {
    document.removeEventListener('mousedown', this.handleClickOutside);
    this.viewerAnnos.removeHandler('canvas-click', this.handleViewerClick);
    window.removeEventListener("resize", this.resize);
/*************  ✨ Windsurf Command ⭐  *************/
  /**
   * Lifecycle hook mounted, called after the component has been mounted.
   * Listens for mousedown event on document and logs debug information.
   * Sets isMounted to true and dontShowTree to true if treeShowOption is true or hideTree is true.
   * Calls initNewAnnotatedImage with true as argument and updates selectedAnnos.
   * Calls goHome on viewerAnnos after 500ms.
   */
/*******  7a15a63a-2cae-412c-966c-0ab818c8dfd0  *******/    if (this.getAccessLevel(this.image) === 2) {
      // this.$refs['osdDiv'].removeEventListener('wheel', this.handleScroll);
    }
  },
  beforeMount:function(){

  },


  mounted:function () {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.$log.debug("annotatedImageView mounted", this.image, this.highlightedAnnotations, this.item);
    this.isMounted = true
    if (this.treeShowOption){
      this.dontShowTree = true
    }
    if (this.hideTree){
      this.dontShowTree = true
    } else {
      this.dontShowTree = false
    }
    this.initNewAnnotatedImage(true)
    this.updateSelectedAnnos()
    const _self = this
    if (this.viewerAnnos){
      setTimeout(function(){
        _self.viewerAnnos.viewport.goHome(true)
      }, 500);
    }
  }
}
</script>

<style lang="css" >

.fullHight {
  height: 100% !important;
}
.theme--light.v-tabs > .v-tabs-bar {
  background-color: rgba(255, 255, 255, 0.0) !important;
}
.a9s-outer {
  transition: fill 1s, stroke-width 0.7s;
  stroke: #fff000;
  fill: rgba(0, 128, 0,0.25);
  stroke-width:0px;
  display: inline !important;
}
.a9s-inner {
  transition: fill 1s, stroke-width 0.7s;
  stroke: #fff000;
  fill: rgba(0, 128, 0,0);
  stroke-width:0px;
  display: inline !important;
}
.hidden {
  visibility: hidden;
}

.visible {
  visibility: visible;
}
#instructions {
  pointer-events: none!important;
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  font-size: 16px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.a9s-annotation.highlight .a9s-inner {
  transition: fill 1s, stroke-width 0.7s;
  stroke: #fff000;
  fill: rgba(0, 128, 0,0.25)!important;
  stroke-width:0px!important;
}

.a9s-annotation.highlight .a9s-outer:hover {
  transition: fill 1s, stroke-width 0.7s;
  stroke-width:0px;
  fill: rgba(255, 255, 255, 0);
}
.a9s-annotation.highlight .a9s-outer {
  transition: fill 1s, stroke-width 0.7s;
  stroke: #fff000;
  fill: rgba(0, 128, 0,0);
  stroke-width:0px;
}
.a9s-annotation.hide .a9s-outer {
  transition: fill 1s, stroke-width 0.7s;
  stroke: #fff000;
  fill: rgba(0, 128, 0,0);
  stroke-width:0px;
}

.a9s-annotation.hide .a9s-outer:hover {
  transition: fill 1s, stroke-width 0.7s;
  stroke-width:0px;
  fill: rgba(255, 255, 255, 0);
}
.a9s-annotation.hide .a9s-inner {
  transition: fill 1s, stroke-width 0.7s;
  fill: rgba(255, 255, 255, 0);
  stroke-width:0px;
}

.a9s-annotation.hide .a9s-inner:hover {
  stroke: #fff000;
  vector-effect: none;
  fill: rgba(0, 128, 0,0);
  stroke-width:0px;
  transition: fill 1s, stroke-width 0.7s;
}
.tree-height{
  padding-bottom: 180px;
}
.v-bottom-sheet.v-dialog {
}
.primary {
  background-color: var(--v-primary-base)!important; /* Vuetify-Farbe */
}
</style>
